import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PermissionService } from '../../permission/+state/permission.service';
import { PermissionBasedAuthGuardService } from '../../permission/services/permission-based-auth-guard.service';

@Injectable({
  providedIn: 'root',
})
export class RotaAuthGuardService extends PermissionBasedAuthGuardService {
  protected permissionService = inject(PermissionService);
  protected router = inject(Router);

  protected readonly activated = false;
  protected readonly matchPolicy = 'all';
  protected readonly failureUrl = 'rota/access-request';
  protected readonly requiredPermissions = [];
}
